import { put, takeLatest } from "redux-saga/effects";
import { getRequest, showError } from "../components/commonUtilities";
import { mapLayersReceived } from "../actions/MapLayer";
import { GET_MAP_LAYERS, GetMapLayers, MapLayersReceived } from "../actions/MapLayer/types";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* getMapLayers(
    action: GetMapLayers
): Generator<
    Promise<MapLayersReceived> | GeneratorYieldType<MapLayersReceived["payload"]>,
    void,
    MapLayersReceived["payload"]["data"]
> {
    try {
        const json = yield getRequest("/api/map_layer/", action.payload.params);

        yield put(mapLayersReceived({ data: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getMapLayersSaga() {
    yield takeLatest(GET_MAP_LAYERS, getMapLayers);
}
